import type { Config } from "@App/configs/interfaces";

export const config: Partial<Config> = {
  slug: "athlon",
  homeSections: {
    image: { src: "/images/partner/athlon/athlon_list_items.webp", alt: "Athlon" },
    showBenefits: false,
  },
};

export default config;
